export const findMarketByContractType = (markets = [], user) =>
	markets?.find(
		(market) =>
			market.short === user?.contract_type.split('_')[0].toLowerCase(),
	);
